export default __webpack_public_path__ + "cc831805e42b3f7c558811cf984fde58.jpg";